module.exports = __webpack_public_path__ + "img/product-image.4e041c5f.webp";